import { makeRoute } from "@/lib/makeRoute";
export const Route = makeRoute("/nl/contact", "nl", "contact");
